/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { AsnHeadersService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { AsnHeaderStore } from './asn-header.store';
import {
    AsnHeaderCreate,
    AsnHeaderRead,
    AsnHeaderSearchParams,
} from '../../entities/asn-header.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class AsnHeaderDataService extends AbstractDataService<
    AsnHeaderRead,
    AsnHeaderCreate
> {
    protected EntityName = PFWmsEntities.AsnHeader;
    constructor(
        private service: AsnHeadersService,
        store: AsnHeaderStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(body: AsnHeaderCreate): Observable<AsnHeaderRead> {
        return this.service.asnHeaderCreate({
            asnHeaderViewModelCreateBody: body,
        }) as Observable<AsnHeaderRead>;
    }
    protected deleteObs$(id: string): Observable<AsnHeaderRead> {
        return this.service.asnHeaderDelete({
            id,
        }) as Observable<AsnHeaderRead>;
    }
    protected undoDeleteObs$(id: string): Observable<AsnHeaderRead> {
        return this.service.asnHeaderUndoDelete({
            id,
        }) as Observable<AsnHeaderRead>;
    }
    protected getObs$(id: string): Observable<AsnHeaderRead> {
        return this.service.asnHeaderReadById({
            id,
        }) as Observable<AsnHeaderRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<AsnHeaderRead> {
        return this.service.asnHeaderUpdatePatch({
            id,
            operation: operations,
        }) as Observable<AsnHeaderRead>;
    }
    protected searchObs$(
        searchParams: AsnHeaderSearchParams
    ): Observable<IPagedResult<AsnHeaderRead>> {
        return this.service.asnHeaderSearch(searchParams) as Observable<
            IPagedResult<AsnHeaderRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<AsnHeaderRead>>> {
        return this.service.asnHeaderGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<AsnHeaderRead>>
        >;
    }
}
